import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './main.scss';
import App from './App';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/auth/AuthProvider';
import { PurchaseProvider } from './context/purchase/PurchaseProvider';
import './lib/sentry';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <StrictMode>
    <AuthProvider>
      <PurchaseProvider>
        <>
          <App />
          <Toaster
            position="top-center"
            toastOptions={{
              style: { background: '#111827', color: '#f9fafb' },
              success: { style: { background: '#166534', color: '#f9fafb' } },
              error: { style: { background: '#991b1b', color: '#f9fafb' } },
            }}
          />
        </>
      </PurchaseProvider>
    </AuthProvider>
  </StrictMode>
);
